<template>
  <!-- name: '我要捐 快捷捐物' -->
  <div class="fastThingsWrap">
    <div class="searchBox">
      <button class="allBtnClass" @click="allChange()">全部</button>
      <div class="selectBox">
        <div class="selectClass" @click="isShow = !isShow">
          {{ curSelect }}
          <img src="https://img.bbalt.cn/imgh5/donate/icon_narrow_down.svg" alt="" />
        </div>
        <ul v-show="isShow">
          <li
            :value="item"
            v-for="(item, index) in optionList"
            :key="index"
            @click="handleChange(item)"
          >
            {{ item }}
            <img
              v-if="item === curSelect"
              src="https://img.bbalt.cn/imgh5/donate/icon_tick.svg"
              alt=""
            />
          </li>
        </ul>
      </div>
    </div>
    <van-loading v-if="isShowLoading">加载中...</van-loading>
    <div class="listBox" v-else>
      <!-- <div class="listClass" v-for="(item, index) in curDataList" :key="index"> -->
      <div class="listClass">
        <!-- <h4>{{ item.nameCn }}</h4> -->
        <ul>
          <li
            v-for="(subItem, subIndex) in curDataList"
            :key="subIndex"
            v-show="subItem.nameCn"
          >
            <div :class="'color' + (subIndex % 3) + ' shortTitle'">
              {{ subItem.nameCn ? subItem.nameCn.charAt(0, 1) : "" }}
            </div>
            <div class="infoBox">
              <span>{{ subItem.goodsName }}</span>
              <span>总缺 {{ subItem.insufficiency }} 件</span>
            </div>
            <div class="countBox">
              <img
                src="https://img.bbalt.cn/imgh5/userCenter/icon_minus.svg"
                alt=""
                @click="
                  () => {
                    subItem.donatedCount--;
                    subItem.donatedCount < 0 && (subItem.donatedCount = 0);
                  }
                "
              />
              <input
                type="tel"
                class="numberboxClass"
                v-model="subItem.donatedCount"
                @mousedown="curCount = subItem.donatedCount"
              />
              <img
                src="https://img.bbalt.cn/imgh5/userCenter/icon_add.svg"
                alt=""
                @click="subItem.donatedCount++"
              />
            </div>
          </li>
        </ul>
      </div>
      <div class="noDataBox" v-show="curDataList.length === 0">
        <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
        暂无数据
      </div>
    </div>
    <div class="btnBox">
      <button class="btnDonateClass" @click="handleDonate()">立即捐赠</button>
    </div>
    <div class="fixBox" style="display: none;">
      <div class="titleBox">
        <img src="https://img.bbalt.cn/imgh5/donate/icon_store.png" alt="" />
        捐物给慈善商店
        <img src="https://img.bbalt.cn/imgh5/donate/icon_next.png" alt="" />
      </div>
      <p>暂时捐不出的衣物，可「登记可捐衣服」</p>
    </div>
  </div>
</template>

<script>
import { fastGoods, list } from "@/api/donate";
import { myDonatemMatch } from "@/api/other";
export default {
  components: {},
  data() {
    return {
      optionList: ["图书", "纺织品", "文具"],
      curSelect: "筛选",
      isShow: false,
      dataList: [
        {
          type: "图书",
          shortTitle: "书",
          list: [
            { classify: "中外历史", lackNum: "4", count: 0 },
            { classify: "儿童文学", lackNum: "4", count: 0 },
          ],
        },
        {
          type: "纺织品",
          shortTitle: "织",
          list: [{ classify: "牛仔布料", lackNum: "4", count: 0 }],
        },
        {
          type: "文具",
          shortTitle: "文",
          list: [{ classify: "笔记本", lackNum: "4", count: 0 }],
        },
      ],
      curDataList: [],
      isShowLoading: true,
    };
  },
  created() {
    this.setCurDataList();
    // this.curDataList = this.dataList;
    this.getFastGoods();
  },
  methods: {
    handleChange(item) {
      this.isShowLoading = true;
      this.curSelect = item;
      this.isShow = false;
      this.getList();
      this.setCurDataList();
    },
    setCurDataList() {
      if (this.curSelect !== "筛选") {
        this.curDataList = this.dataList.filter((e) => {
          if (e.type === this.curSelect) {
            return e;
          }
        });
      }
    },
    allChange() {
      this.curDataList = this.dataList;
      this.isShow = false;
      this.curSelect = "筛选";
    },
    async getFastGoods() {
      const { content } = await fastGoods();
      this.curDataList = content;
      this.isShowLoading = false;
    },
    async getList() {
      const { content } = await list({
        nameCns: this.curSelect !== "筛选" ? this.curSelect : "图书",
      });
      this.curDataList = content;
      this.isShowLoading = false;
    },
    // handleCount(index, subIndex, val) {
    //   if (val < 0 || !Number(val)) {
    //     this.curDataList[index].list[subIndex].donatedCount = 0;
    //   }
    // },
    async handleDonate() {
      let tempData = [];
      this.curDataList.map((item) => {
        if (item.donatedCount > 0) {
          tempData.push({
            categoryId: "",
            donateCount: item.donatedCount,
            goodsId: item.goodsId
          });
        }
      });
      if (tempData.length > 0) {
        const { code, message, content } = await myDonatemMatch({
          type: 2,
          detailArgList: tempData
        });
        if (code === 200) {
          this.$router.push({
            path: "/userCenterThird",
            query: { title: "可捐物品匹配", data: JSON.stringify(content), donateType: 2, code: content.code },
          });
        } else {
          this.$toast.fail(message);
        }
      } else {
        this.$toast.fail("请选择要匹配的数据");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.fastThingsWrap {
  height: 78vh;
  width: 100%;
  overflow: auto;
  padding-bottom: 37px;
  border-top: 1px solid #ededed;
  .searchBox {
    margin: 22px 32px 15px 32px;
    display: flex;
    justify-content: space-between;
    .allBtnClass {
      width: 178px;
      height: 72px;
      background: #eeeeee;
      border-radius: 36px;
      border: 1px solid #dddddd;
    }

    .selectBox {
      width: 180px;
      height: 72px;
      position: relative;
      .selectClass {
        background: #eeeeee;
        border-radius: 36px;
        border: 1px solid #dddddd;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          margin-left: 8px;
        }
      }
      ul {
        position: absolute;
        top: 88px;
        left: -30px;
        width: 208px;
        background: #eeeeee;
        border-radius: 24px;
        display: flex;
        flex-flow: column;
        li {
          padding-left: 32px;
          margin: 18px 0px;
          height: 36px;
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          padding-right: 16px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }

  .listBox {
    font-family: PingFangSC, PingFang SC;
    min-height: 450px;
    .listClass {
      h4 {
        margin: 15px 0px 15px 32px;
        height: 34px;
        font-size: 26px;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
      }
      ul {
        width: 100%;
        background: #ffffff;
        display: flex;
        flex-flow: column;
        li {
          display: flex;
          justify-self: flex-start;
          align-items: center;
          height: 128px;
          border-bottom: 1px solid #ededed;
          margin: 0px 32px;
          .shortTitle {
            width: 80px;
            height: 80px;
            font-size: 30px;
            font-weight: 400;
            line-height: 80px;
            text-align: center;
            border-radius: 50%;
            margin-right: 32px;
          }
          .infoBox {
            display: flex;
            flex-flow: column;
            width: 55%;
            span {
              font-size: 26px;
              font-weight: 400;
              &:first-child {
                color: #333333;
                margin-bottom: 4px;
              }
              &:last-child {
                color: #999999;
              }
            }
          }
          .countBox {
            width: 164px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
            }
            .numberboxClass {
              width: 56px;
              height: 36px;
              background: #f5f5f5;
              border-radius: 2px;
              border: none;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .btnBox {
    margin-top: 24px;
    display: flex;
    justify-content: center;

    button {
      width: 335px;
      height: 96px;
      background: #ffffff;
      border-radius: 48px;
      border: 2px solid #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      font-weight: 400;
      color: #333333;
      img {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      &.btnDonateClass {
        background: #fe66a6;
        font-size: 32px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .fixBox {
    width: calc(100% - 40px);
    height: 124px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/bg_fix.png");
    background-repeat: no-repeat;
    background-size: 100% 124px;
    margin: 0px 20px;
    position: fixed;
    bottom: 170px;
    .titleBox {
      margin-top: 23px;
      margin-left: 52px;
      height: 40px;
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        &:first-child {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
        &:last-child {
          width: 30px;
          height: 30px;
          margin-left: 24px;
        }
      }
    }
    p {
      margin-top: 9px;
      margin-left: 52px;
      height: 28px;
      font-size: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
    }
  }

  .color0 {
    color: #a0be5b;
    background-color: rgba(160, 190, 91, 0.2);
  }
  .color1 {
    color: #928dcc;
    background-color: rgba(146, 141, 204, 0.2);
  }
  .color2 {
    color: #679fd2;
    background-color: rgba(103, 159, 210, 0.1);
  }
}
.noDataBox {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  img {
    width: 80%;
    margin: 30px auto;
  }
}
.van-loading {
  text-align: center;
}
</style>
